import type { ClientAdPlacement } from '@schibsted-nmp/advertising-shared';

export function shouldCollapse(placement: ClientAdPlacement) {
  return ['error', 'collapsedOnCollision'].includes(placement.status);
}
